module.exports = __webpack_public_path__ + "static/media/reports_selected.f9e814a3.svg";